import type { FaireProductEntity } from "../../entity_types/product";

export const p_5tcnpb9ete: FaireProductEntity = {
  token: "p_5tcnpb9ete",
  type: "product",
  name: "I Love Cock And Hate The Government Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/08c7578a7d94969df7475a86989fcad012645a5a7fad05ab9215bc491353f468.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f96e2af11ea46eda1664d5ae89334e6e7b961cfdf2319266e1cec9f118a49031.jpeg",
    "https://cdn.faire.com/fastly/0d52a366ac974381ba7da0103f4775062c6c42a9ec51f80e24486aaecee0c58a.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/338a2947a00a1bf857aa977dd775220f8ae892d1d4fe06bd8b6c365cd8536479.jpeg",
    "https://cdn.faire.com/fastly/ead9de351a438004e919ae9c418ab4fc19da48da2618a5b3bb79c7d074be9998.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the rebel that doesn't choke on their words (or anything else, for that matter) and knows where they stand on the real issues.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:51.358Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
